import { Buffer } from 'buffer';

export default class Base64Utils {
  static encode(stringValue) {
    return Buffer.from(stringValue).toString('base64');
  }

  static decode(encodedValue) {
    return Buffer.from(encodedValue, 'base64').toString('utf8');
  }
}
